<template>
  <h4
    class="pb-report-title"
  >
    <BaseButton
      class="pb-report-fold"
      :class="state ? 'pb-report-fold-up' : 'pb-report-fold-down'"
      @click="toggle"
    >
      <UiIcon
        :icon="state ? 'minus' : 'add'"
        size="small"
      />
    </BaseButton>
    <PbLink
      v-if="tree.link"
      :to="tree.link"
    >
      {{ tree.name }}
    </PbLink>
    <template v-else>
      {{ translate('pb2.reportTree.rootElement') }}
    </template>
  </h4>
  <template v-if="tree.reports && tree.reports.length">
    <ul
      v-show="state"
      class="pb-report-group"
    >
      <li
        v-for="reportItem in tree.reports"
        :key="reportItem.message"
        class="pb-report-message"
      >
        <UiBadge
          :color="reportItem.level"
          class="pb-report-message-badge"
        >
          {{ reportItem.level }}
        </UiBadge>
        <span
          class="pb-report-message-text"
          :class="`txt-${reportItem.level}`"
        >
          {{ reportItem.message }}
        </span>
      </li>
    </ul>
  </template>
  <template v-if="tree.modes && Object.keys(tree.modes).length">
    <!-- Modes: -->
    <ul
      v-show="state"
      class="pb-report-group"
    >
      <li
        v-for="mode in tree.modes"
        :key="mode.uid"
        class="pb-report-item"
      >
        <ReportTree
          :tree="mode"
          :default-state="state"
        />
      </li>
    </ul>
  </template>
  <template v-if="tree.channels && Object.keys(tree.channels).length">
    <!-- Channels: -->
    <ul
      v-show="state"
      class="pb-report-group"
    >
      <li
        v-for="channel in tree.channels"
        :key="channel.uid"
        class="pb-report-item"
      >
        <ReportTree
          :tree="channel"
          :default-state="state"
        />
      </li>
    </ul>
  </template>
  <template v-if="tree.presetRanges && Object.keys(tree.presetRanges).length">
    <!-- Preset ranges: -->
    <ul
      v-show="state"
      class="pb-report-group"
    >
      <li
        v-for="presetRange in tree.presetRanges"
        :key="presetRange.uid"
        class="pb-report-item"
      >
        <ReportTree
          :tree="presetRange"
          :default-state="state"
        />
      </li>
    </ul>
  </template>

  <template v-if="tree.presets && Object.keys(tree.presets).length">
    <!-- Presets: -->
    <ul
      v-show="state"
      class="pb-report-group"
    >
      <li
        v-for="preset in tree.presets"
        :key="preset.uid"
        class="pb-report-item"
      >
        <ReportTree
          :tree="preset"
          :default-state="state"
        />
      </li>
    </ul>
  </template>
</template>

<script setup>
import UiIcon from '@nicolaudie-group/ng-ui-kit/components/UiIcon/UiIcon.vue'
import BaseButton from '@nicolaudie-group/ng-ui-kit/components/BaseButton/BaseButton.vue'
import UiBadge from '@nicolaudie-group/ng-ui-kit/components/UiBadge/UiBadge.vue'
import useComputedToggle from '@nicolaudie-group/ng-ui-kit/composables/useComputedToggle'
import PbLink from '@/components/PbLink.vue'
import useTranslate from '@/composables/useTranslate'

const props = defineProps({
  tree: { type: Object, default: () => ({}) },
  defaultState: { type: Boolean, default: true },
})

const { translate } = useTranslate()

const { state, toggle } = useComputedToggle(() => {
  const treeState = props.tree.state
  const defaultStateProp = props.defaultState
  return typeof treeState === 'undefined' ? defaultStateProp : treeState
})
</script>

<style lang="scss">
@use '@nicolaudie-group/ng-ui-kit/defines/_fonts.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_colors.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_config.define.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_flexbox.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_generic.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_responsive.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_theme.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_animations.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_transitions.mixin.scss';

@use '/src/styles/_pb.scss';

.pb-report-item {
  list-style-type: none;
}

.pb-report-title {
  padding: pb.$quarter-spacing 0 0 0;
}

.pb-report-message {
  list-style-type: none;
  padding: pb.$quarter-spacing 0;
  margin-left: -8px;
}

.pb-report-message-text {
  vertical-align: middle;
}

.pb-report-group {
  border-left: 1px solid colors.$color-default--gray-border;
  padding-left: pb.$spacing + 2px;
}

.pb-report-fold {
  box-sizing: border-box;
  width: 1.5em;
  height: 1.5em;
  padding: 0;
  text-align: center;
  background-color: colors.$color-default--white;
  border: 1px solid colors.$color-default--gray-border;
  border-radius: .75em;
  color: #909090;
  margin-right: 5px;
  margin-left: -8px;
}
</style>
